import axios from 'axios';
import { setupAuthInterceptor, retryWithBackoff } from '../common';
import { wrapAxiosInstance } from '../cache/modules/axiosFactory';
import { NAMESPACES } from '../configuration';
const BASE_URL = NAMESPACES.management_api.terminals;

// Axios instance with auth interceptor (token managed automatically)
const api = setupAuthInterceptor(axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  }
}));

// Cached API wrapper - 5m TTL for terminal config data
const cachedApi = wrapAxiosInstance(api, {
  namespace: 'management_api',
  group: 'terminals',
  defaultTtl: '5m',
  hashLargeSegments: true,
  emitMeta: true,
});

// =====================
// READS (cached)
// =====================

// Function to fetch all terminals
export const getAllTerminals = async () => {
  return await retryWithBackoff(() => cachedApi.get('/GetAllTerminals'));
};

// get all terminals by local id
export const getAllTerminalsByLocalId = async (localId: string) => {
  return await retryWithBackoff(() => cachedApi.get(`/GetAllTerminalsByLocalId/${localId}`));
};

// =====================
// MUTATIONS (no cache, invalidate after)
// =====================

// /UpdateTerminal/<int:terminal_id>
export const updateTerminal = async (terminalsId: number, terminalData: any) => {
  const res = await retryWithBackoff(() => api.put(`/UpdateTerminal/${terminalsId}`, terminalData));
  await cachedApi.clear();
  return res;
};

export const createTerminal = async (terminalData: any) => {
  const res = await retryWithBackoff(() => api.post('/CreateTerminal', terminalData));
  await cachedApi.clear();
  return res;
};

export const deleteTerminal = async (providerId: number) => {
  const res = await retryWithBackoff(() => api.delete(`/DeleteTerminal/${providerId}`));
  await cachedApi.clear();
  return res;
};